import { calcBiasedRandomNbr } from "../../../objects/CommonUse/randomBias";

export const getCompanyMatchRate = () => {
  
    //  calc a random number from 3 to 6 that is biased toward 5%
    let companyMatchRate = (calcBiasedRandomNbr(3, 6, 5, .75))/100;  
    if (companyMatchRate === 0){
        companyMatchRate = .03;
    }
    
    return companyMatchRate;
}
export default getCompanyMatchRate;